import { createI18n } from "vue-i18n/dist/vue-i18n.runtime.esm-bundler.js";
import en from './locales/en.json';

const i18n = createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {
    en
  }
});

export default i18n;
